import { useState, useEffect } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { UseAxios } from '../../../common/useAxios';

interface PrmInfo {
    param_name?: string;
    param_seq?: string;
}

function ParameterTab({ prmInfo, setPrmInfo }: { prmInfo: PrmInfo[], setPrmInfo: React.Dispatch<React.SetStateAction<any>> }) {

    //    const [prmInfo, setPrmInfo] = useState<PrmInfo[]>([]);

    /*
    const { loading, data, error, refetch } = UseAxios({
        method: "post",
        url: "http://localhost:5000/api/request/",
        data: {
            program_id: "PERCENT-ADMIN-PRG-L-LSPARAMSBYPROGRAMID",
            params: {
                program_id: program_id,
            },
            page_index: -1,
        },
    });



    useEffect(() => {
        console.log("parameter");


        const paramData = data?.data?.data;



        if (paramData) {
            console.log("SSSSSSSS2222");
            console.log(paramData);

            const prmInfoData = paramData.map((item: any) => ({
                param_name: item.param_name,
                param_seq: item.param_seq.toString()
            }));

            console.log("s3333333333333");
            console.log(prmInfoData);
            setPrmInfo(prmInfoData);
        }
    }, [data]);
*/

    //useEffect(() => { setPrmInfo(parameterList) }, [parameterList])





    const onParameterAddClick = () => {
        setPrmInfo([...prmInfo, { param_name: "", param_seq: "" }]);
    };

    const onMoveUpClick = (index: number) => {
        if (index === 0) return; // 첫 번째 항목이면 더 이상 위로 이동할 수 없음

        const updatedParameterList = [...prmInfo];
        // 현재 항목과 바로 위 항목을 서로 교환
        [updatedParameterList[index - 1], updatedParameterList[index]] = [
            updatedParameterList[index],
            updatedParameterList[index - 1],
        ];
        setPrmInfo(updatedParameterList);
    };

    const onMoveDownClick = (index: number) => {
        if (index === prmInfo.length - 1) return; // 마지막 항목이면 더 이상 아래로 이동할 수 없음

        const updatedParameterList = [...prmInfo];
        // 현재 항목과 바로 아래 항목을 서로 교환
        [updatedParameterList[index].param_name, updatedParameterList[index + 1].param_name] = [
            updatedParameterList[index + 1].param_name,
            updatedParameterList[index].param_name,
        ];
        setPrmInfo(updatedParameterList);
    };

    const onDeleteParameterClick = (index: number) => {
        const updatedParameterList = [...prmInfo];
        updatedParameterList.splice(index, 1);
        setPrmInfo(updatedParameterList);
    };


    return (
        <div className=" flex flex-col w-full bg-gray-900 text-body px-10 py-8 text-white overflow-auto " style={{ height: "80vh" }}>
            <button
                className="group relative h-8 w-full  rounded-lg bg-indigo-500 text-md font-bold text-white"
                onClick={onParameterAddClick}
            >
                Add Parameter
                <div className="absolute inset-0 h-full w-full scale-0 rounded-lg transition-all duration-300 group-hover:scale-100 group-hover:bg-white/30"></div>
            </button>
            {prmInfo.length > 0 && (
                <table className="table-auto w-full mt-4">
                    <thead>
                        <tr>
                            <th className="px-4 py-2 border border-slate-700 text-body" style={{ width: "20%" }}>
                                {" "}
                            </th>
                            <th className="px-4 py-2 border border-slate-700" style={{ width: "40%" }}>
                                Parameter
                            </th>
                            <th className="px-4 py-2 border border-slate-700" style={{ width: "40%" }}>
                                Delete
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {prmInfo.map((item, index) => (
                            <tr key={index}>
                                <td className="border py-2 border-slate-700 text-center" style={{ width: "20%" }}>
                                    <div className="flex flex-row justify-between ml-2">
                                        <div className="flex flex-col space-y-2">
                                            <FaChevronUp
                                                className="cursor-pointer  hover:text-cyan-400 transition-all duration-200"
                                                onClick={() => onMoveUpClick(index)}
                                            />
                                            <FaChevronDown
                                                className="cursor-pointer  hover:text-cyan-400 transition-all duration-200"
                                                onClick={() => onMoveDownClick(index)}
                                            />
                                        </div>

                                        <div className="text-body  w-full flex justify-center items-center mr-4">
                                            {index + 1} {/* Adjust the displayed index */}
                                        </div>
                                    </div>
                                </td>
                                <td className="border px-4 py-2 border-slate-700 items-center" style={{ width: "40%" }}>
                                    <input
                                        className="appearance-none border-none block w-full rounded bg-slate-500 bg-opacity-50 p-2 leading-tight outline-none text-white focus:bg-opacity-100 transition-all duration-300"
                                        id={index + ""}
                                        type="text"
                                        value={item.param_name}
                                        /*
                                        onChange={(e) => {
                                            const updatedParameterList = prmInfo.map((p, i) =>
                                                i === index ? { param_seq: (i + 1).toString(), param_name: e.target.value } : p
                                            );
                                            setPrmInfo(updatedParameterList);
                                        }}
                                        */
                                        onChange={(e) => {
                                            const updatedParameterList = prmInfo.map((p, i) => {
                                                if (i === index) {
                                                    const newValue = e.target.value;
                                                    // 화이트 스페이스만 있는 경우 그대로, 문자가 포함된 경우 trim 처리
                                                    return {
                                                        param_seq: i + 1,
                                                        param_name: newValue.trim() === "" ? newValue : newValue.trim(),
                                                    };
                                                }
                                                return p;
                                            });
                                            setPrmInfo(updatedParameterList);
                                        }}
                                    />
                                </td>
                                <td className="border px-12 py-3 border-slate-700" style={{ width: "40%" }}>
                                    <button
                                        className="group relative h-8 w-full overflow-hidden rounded-lg bg-teal-500 text-md font-bold text-white"
                                        onClick={() => onDeleteParameterClick(index)}
                                    >
                                        Delete
                                        <div className="absolute inset-0 h-full w-full scale-0 rounded-lg transition-all duration-300 group-hover:scale-100 group-hover:bg-white/30"></div>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

export { ParameterTab };